import { Grid } from "@material-ui/core";
import { Container, Typography } from "@mui/material";
import DesktopMacTwoToneIcon from "@material-ui/icons/DesktopMacTwoTone";
import BrushTwoToneIcon from "@material-ui/icons/BrushTwoTone";
import PhoneAndroidTwoToneIcon from "@material-ui/icons/PhoneAndroidTwoTone";
import React from "react";
import "./MyService.css";
const Myservice = () => {
  return (
    <div>
      <section class="services" id="services">
        <Container>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div>
              <Typography variant="h4" style={{ color: "#fff" }}>
                {" "}
                Services
              </Typography>
              <div
                style={{
                  borderBottom: "2px solid #fff",
                  display: "flex",
                  justifyContent: "center",
                }}
              ></div>
            </div>
          </div>
          <br />
          <Grid item container>
            <Grid items sx={12} md={4} className="box-service">
              <Typography variant="h4">Web Development</Typography>
              <DesktopMacTwoToneIcon className="icon" />
              <Typography variant="h6">
                Your apps, your style, create them any way you want with
              </Typography>
            </Grid>
            <Grid items sx={12} md={4} className="box-service">
              <Typography variant="h4">UI/UX Design</Typography>
              <BrushTwoToneIcon className="icon" />
              <Typography variant="h6">
                Designing is not just what it looks like and feels like. Design
                is how it works
              </Typography>
            </Grid>
            <Grid items sx={12} md={4} className="box-service">
              <Typography variant="h4">Apps Development</Typography>
              <PhoneAndroidTwoToneIcon className="icon" />
              <Typography variant="h6">
                Build apps that users love. Simple as that
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </section>
    </div>
  );
};

export default Myservice;
